<template>
    <div>
      <radiology-view :selected="selected" :masterData="radiolistt" v-if="radiologyViewFlag" v-on:close="closewindow" />
      <template v-else>
        <button class="sa-btn-back"  @click="$parent.referRadiology = false">
        <i class="icon-arrow-left"></i>
      </button>
        <h5 class="sa-card-tit">Select Radiology</h5>
        <div class="sa-card">
          <div class="sa-row" >
            <div class="sa-col-xs12 sa-col-sm12 sa-col-md3 sa-col-lg3">
              <div class="sa-form-group">
                <input type="text" class="sa-form-control sa-dark-search" v-model="clinicInfoReq" placeholder="Search Test" id="Search Test" name="Search Test" /><i class="icon-search sa-search"></i>
              </div>
            </div>
          </div>
          <div class="sa-test-pack-check">
            <div class="sa-form-group" v-for="(radio) in radiolistt" :key="radio.tsk_id">
             <input type="checkbox" :id="radio.tsk_id" v-model="selected" :name="radio.tsk_nm" :value="radio.tsk_id">
                <label :for="radio.tsk_id">{{radio.tsk_nm}}</label>
            </div>
          </div>
        </div>
        <div class=" sa-mt40 sa-text-right ">
            <button :disabled="selected && selected.length <= 0" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" @click="radiology">Continue</button>
        </div>
      </template>
    </div>
</template>
<script>
import RadiologyViewVue from './RadiologyView.vue'
import { pro_url } from "../../../../../config/endpoints";
export default {
  props:["rad"],
    components: {
      'radiology-view': RadiologyViewVue
    },
    data(){
       return{
         checked:[],
         clinicInfoReq:"",
         radiologyFlag: false,
         radiologyViewFlag: false,
         searchName:'',
         radiolistt:[],
         selected: [],
       }
    },
    mounted () {
      this.selected = (this.rad && this.rad.length )? this.rad: []
      this.getRadiology()
    },
    methods: {
      radiology() {
        if(!this.radiologyFlag) {
          this.radiologyFlag = true
          this.radiologyViewFlag = true
        }else {
          this.radiologyFlag = false
          this.radiologyViewFlag = false
        }
      },
      closewindow(){
        this.$parent.referRadiology = false
        this.$parent.getReferralData();
      },
      valueChecker(id){
           let data = this.selected
             return data.find(function(el){
                return el.id == id ? true : false
                });
          },
      getRadiology () {
        let _self = this
         _self.loader = true;
        _self.$store.dispatch("httpPost", {
            uri: `${pro_url}/refer/treatmentDetails`,
            body: {
                "mtype": 6,  
                "limit": 1000,
                "page": 1,
                "name": _self.searchName,
                "prd_id":'ST031'
            }
            }).then(response => {
            if (response && response.status === 1000) {
              console.log(response,'responseresponseresponseresponse')
               _self.loader = false;
                _self.radiolistt = response.data.data 
            }
        })
      },
      
    }
}
</script>
